import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { resolveJob, errText } from "@/lib/fbLabApi";

// Unconfirmed Group posting attempt: resolve it here (same backend as Facebook Lab → Publish) so another attempt is possible.
export function UnconfirmedRecovery({ job, onDone }) {
  const [mode, setMode] = useState(null);
  const [url, setUrl] = useState("");
  const [sure, setSure] = useState(false);
  const [busy, setBusy] = useState(false);
  const go = async (outcome) => {
    setBusy(true);
    try {
      const r = await resolveJob(job.id, outcome === "published" ? { outcome, post_url: url.trim() } : { outcome, note: "Confirmed in Horse Workspace: not published and not pending approval." });
      toast.success(r.pending ? r.message : outcome === "published" ? "Post linked to this horse" : "Attempt cleared. You can post again.");
      onDone();
    } catch (e) { toast.error(errText(e)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="group-recovery" className="rounded-lg border border-red-200 bg-red-50/60 p-3 space-y-2 text-sm">
      <p className="text-red-900">The extension couldn't confirm whether this ad was posted. Check the group, then tell us what happened.</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant={mode === "posted" ? "default" : "outline"} data-testid="group-recovery-posted" onClick={() => setMode("posted")}>I Posted It</Button>
        <Button size="sm" variant={mode === "not" ? "default" : "outline"} data-testid="group-recovery-not-posted" onClick={() => setMode("not")}>I Did Not Post</Button>
      </div>
      {mode === "posted" && (
        <div className="flex flex-col sm:flex-row gap-2">
          <Input data-testid="group-recovery-url" placeholder="Paste the Facebook post link" value={url} onChange={(e) => setUrl(e.target.value)} />
          <Button size="sm" data-testid="group-recovery-posted-save" disabled={busy || !/^https:\/\/(www\.|m\.)?facebook\.com\//i.test(url.trim())} onClick={() => go("published")}>Link post</Button>
        </div>
      )}
      {mode === "not" && (
        <div className="space-y-2">
          <label className="flex items-start gap-2"><Checkbox data-testid="group-recovery-confirm" checked={sure} onCheckedChange={(v) => setSure(!!v)} />I checked the group: this ad was not published and is not waiting for approval.</label>
          <Button size="sm" data-testid="group-recovery-not-save" disabled={busy || !sure} onClick={() => go("not_posted")}>Clear attempt</Button>
        </div>
      )}
    </div>
  );
}
